import Dashboard from '../Dashboard'


function SalePlan() {
  return <Dashboard/>
}

export default SalePlan
